import { NotifyHelper } from "../../../helpers/toast";
import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { eBusDangKyXeActionTypeIds, IBusDangKyXeActionTypes } from "../../action-types/bus/IBusDangKyXeActionTypes";
import { IBusDangKyXePageStateModel } from "../../page-state-model/bus/IBusDangKyXePageState";

const initialState: IBusDangKyXePageStateModel = {
	status: ePageBaseStatus.is_not_initialization,
	bus_dangkyxes: [],
	bus_dangkyxe_editing: undefined,
	bus_dangkyxe_selected_ids: [],
	filter_bus_trangthai_id: 0,
	bus_hinhthuc_dontras: [],
	bus_hinhthuc_dangkys: [],
	bus_loaidiemdons: [],
	bus_trangthai_dangkys: [],
	bus_tuyenduongs: [],
	bus_diemdontras: [],
	is_show_detail_modal: false,
	is_show_delete_confirm: false,
	is_show_import_modal: false,
	is_show_tuyenduong_chitiet_modal: false,
	bus_tuyenduong_chitiet_selected_id: 0,
	bus_tuyenduong_chitiets: [],
	tuyenduong_chitiet_status: ePageBaseStatus.is_not_initialization,
	import_status: ePageBaseStatus.is_not_initialization,
	import_validated_datas: []
}

export const busDangKyXeReducer = (state: IBusDangKyXePageStateModel = initialState, action: IBusDangKyXeActionTypes): IBusDangKyXePageStateModel => {
	switch (action.type) {
		case eBusDangKyXeActionTypeIds.LOAD_START:
			return {
				...state,
				status: ePageBaseStatus.is_loading
			}
		case eBusDangKyXeActionTypeIds.LOAD_SUCCESS:
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				bus_dangkyxes: action.payload
			}
		case eBusDangKyXeActionTypeIds.LOAD_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				bus_dangkyxes: []
			}
		case eBusDangKyXeActionTypeIds.LOAD_DETAIL_START:
			return {
				...state
			}
		case eBusDangKyXeActionTypeIds.LOAD_DETAIL_SUCCESS:
			return {
				...state,
				bus_dangkyxe_editing: action.payload
			}
		case eBusDangKyXeActionTypeIds.LOAD_DETAIL_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state
			}
		case eBusDangKyXeActionTypeIds.LOAD_HINHTHUC_DONTRA_START:
			return {
				...state
			}
		case eBusDangKyXeActionTypeIds.LOAD_HINHTHUC_DONTRA_SUCCESS:
			return {
				...state,
				bus_hinhthuc_dontras: action.payload
			}
		case eBusDangKyXeActionTypeIds.LOAD_HINHTHUC_DONTRA_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				bus_hinhthuc_dontras: []
			}
		case eBusDangKyXeActionTypeIds.LOAD_HINHTHUC_DANGKY_START:
			return {
				...state
			}
		case eBusDangKyXeActionTypeIds.LOAD_HINHTHUC_DANGKY_SUCCESS:
			return {
				...state,
				bus_hinhthuc_dangkys: action.payload
			}
		case eBusDangKyXeActionTypeIds.LOAD_HINHTHUC_DANGKY_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				bus_hinhthuc_dangkys: []
			}
		case eBusDangKyXeActionTypeIds.LOAD_LOAIDIEMDON_START:
			return {
				...state
			}
		case eBusDangKyXeActionTypeIds.LOAD_LOAIDIEMDON_SUCCESS:
			return {
				...state,
				bus_loaidiemdons: action.payload
			}
		case eBusDangKyXeActionTypeIds.LOAD_LOAIDIEMDON_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				bus_loaidiemdons: []
			}
		case eBusDangKyXeActionTypeIds.LOAD_TRANGTHAI_DANGKY_START:
			return {
				...state
			}
		case eBusDangKyXeActionTypeIds.LOAD_TRANGTHAI_DANGKY_SUCCESS:
			return {
				...state,
				bus_trangthai_dangkys: action.payload
			}
		case eBusDangKyXeActionTypeIds.LOAD_TRANGTHAI_DANGKY_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				bus_trangthai_dangkys: []
			}
		case eBusDangKyXeActionTypeIds.LOAD_TUYENDUONG_START:
			return {
				...state
			}
		case eBusDangKyXeActionTypeIds.LOAD_TUYENDUONG_SUCCESS:
			return {
				...state,
				bus_tuyenduongs: action.payload
			}
		case eBusDangKyXeActionTypeIds.LOAD_TUYENDUONG_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				bus_tuyenduongs: []
			}
		case eBusDangKyXeActionTypeIds.LOAD_DIEMDONTRA_START:
			return {
				...state
			}
		case eBusDangKyXeActionTypeIds.LOAD_DIEMDONTRA_SUCCESS:
			return {
				...state,
				bus_diemdontras: action.payload
			}
		case eBusDangKyXeActionTypeIds.LOAD_DIEMDONTRA_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				bus_diemdontras: []
			}
		case eBusDangKyXeActionTypeIds.LOAD_TUYENDUONG_CHITIET_START:
			return {
				...state,
				tuyenduong_chitiet_status: ePageBaseStatus.is_loading
			}
		case eBusDangKyXeActionTypeIds.LOAD_TUYENDUONG_CHITIET_SUCCESS:
			return {
				...state,
				tuyenduong_chitiet_status: ePageBaseStatus.is_completed,
				bus_tuyenduong_chitiets: action.payload
			}
		case eBusDangKyXeActionTypeIds.LOAD_TUYENDUONG_CHITIET_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				tuyenduong_chitiet_status: ePageBaseStatus.is_completed,
				bus_tuyenduong_chitiets: []
			}
		case eBusDangKyXeActionTypeIds.SHOW_DETAIL:
			return {
				...state,
				is_show_detail_modal: true,
				bus_dangkyxe_editing: action.payload
			}
		case eBusDangKyXeActionTypeIds.CLOSE_DETAIL:
			return {
				...state,
				is_show_detail_modal: false,
				bus_dangkyxe_editing: undefined,
				bus_diemdontras: []
			}
		case eBusDangKyXeActionTypeIds.SHOW_TUYENDUONG_CHITIET_MODAL:
			return {
				...state,
				is_show_tuyenduong_chitiet_modal: true,
				bus_tuyenduong_chitiet_selected_id: action.payload,
				bus_tuyenduong_chitiets: []
			}
		case eBusDangKyXeActionTypeIds.CLOSE_TUYENDUONG_CHITIET_MODAL:
			return {
				...state,
				is_show_tuyenduong_chitiet_modal: false,
				bus_tuyenduong_chitiet_selected_id: 0,
				bus_tuyenduong_chitiets: [],
				tuyenduong_chitiet_status: ePageBaseStatus.is_not_initialization
			}
		case eBusDangKyXeActionTypeIds.CHANGE_SELECTED_IDS:
			return {
				...state,
				bus_dangkyxe_selected_ids: action.payload
			}
		case eBusDangKyXeActionTypeIds.CHANGE_FILTER_TRANGTHAI:
			return {
				...state,
				filter_bus_trangthai_id: action.payload
			}
		case eBusDangKyXeActionTypeIds.SHOW_CONFIRM:
			return {
				...state,
				is_show_delete_confirm: true
			}
		case eBusDangKyXeActionTypeIds.CLOSE_CONFIRM:
			return {
				...state,
				is_show_delete_confirm: false
			}
		case eBusDangKyXeActionTypeIds.SAVE_START:
			return {
				...state,
				status: ePageBaseStatus.is_saving
			}
		case eBusDangKyXeActionTypeIds.SAVE_SUCCESS:
			NotifyHelper.Success(action.payload ? "Cập nhật thành công" : "Thêm mới thành công")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				is_show_detail_modal: false,
				bus_dangkyxe_editing: undefined,
				bus_diemdontras: []
			}
		case eBusDangKyXeActionTypeIds.SAVE_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed
			}
		case eBusDangKyXeActionTypeIds.DELETE_START:
			return {
				...state,
				status: ePageBaseStatus.is_deleting
			}
		case eBusDangKyXeActionTypeIds.DELETE_SUCCESS:
			NotifyHelper.Success("Xoá dữ liệu thành công.")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				is_show_delete_confirm: false,
				bus_dangkyxe_editing: undefined,
				bus_dangkyxe_selected_ids: []
			}
		case eBusDangKyXeActionTypeIds.DELETE_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				is_show_delete_confirm: false
			}
		case eBusDangKyXeActionTypeIds.SHOW_IMPORT_MODAL:
			return {
				...state,
				is_show_import_modal: true,
				import_status: ePageBaseStatus.is_not_initialization,
				import_validated_datas: []
			}
		case eBusDangKyXeActionTypeIds.CLOSE_IMPORT_MODAL:
			return {
				...state,
				is_show_import_modal: false,
				import_status: ePageBaseStatus.is_not_initialization,
				import_validated_datas: []
			}
		case eBusDangKyXeActionTypeIds.VALIDATE_IMPORT_START:
			return {
				...state,
				import_status: ePageBaseStatus.is_loading
			}
		case eBusDangKyXeActionTypeIds.VALIDATE_IMPORT_SUCCESS:
			return {
				...state,
				import_status: ePageBaseStatus.is_completed,
				import_validated_datas: action.payload || []
			}
		case eBusDangKyXeActionTypeIds.VALIDATE_IMPORT_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				import_status: ePageBaseStatus.is_completed,
				import_validated_datas: []
			}
		case eBusDangKyXeActionTypeIds.IMPORT_START:
			return {
				...state,
				import_status: ePageBaseStatus.is_saving
			}
		case eBusDangKyXeActionTypeIds.IMPORT_SUCCESS:
			NotifyHelper.Success("Import đăng ký thành công")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				import_status: ePageBaseStatus.is_completed,
				is_show_import_modal: false,
				import_validated_datas: []
			}
		case eBusDangKyXeActionTypeIds.IMPORT_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				import_status: ePageBaseStatus.is_completed
			}
		default:
			return state;
	}
}
